import { useEffect, useRef } from 'react';
import { gsap } from '../lib/gsapSetup';
import SectionTag from '../components/SectionTag';
import { INTRO } from '../content/siteContent';
import { useReducedMotion } from '../hooks/useMotionPrefs';

export default function Intro() {
  const ref = useRef(null);
  const reduced = useReducedMotion();

  useEffect(() => {
    if (reduced) return;
    const ctx = gsap.context(() => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: ref.current,
          start: 'top 65%',
          toggleActions: 'play none none none',
        },
      });
      // Camera pulls back automatically once the section enters
      tl.fromTo('.intro-image', { scale: 1.45 }, { scale: 1, duration: 2.4, ease: 'power2.out' }, 0)
        .fromTo('.intro-title', { yPercent: 40, opacity: 0 }, { yPercent: 0, opacity: 1, duration: 1.1, ease: 'power3.out' }, 0.5)
        .fromTo('.intro-body', { y: 40, opacity: 0 }, { y: 0, opacity: 1, duration: 0.9 }, 1.0);
    }, ref);
    return () => ctx.revert();
  }, [reduced]);

  return (
    <section
      ref={ref}
      id="amaya"
      data-testid="intro-section"
      className="relative h-screen overflow-hidden bg-[#000000]"
    >
      <div className="absolute inset-0">
        <img
          src={INTRO.image}
          alt="Energy infrastructure at night"
          loading="lazy"
          decoding="async"
          className="intro-image h-full w-full object-cover will-change-transform"
        />
        <div className="absolute inset-0 bg-black/55" />
        <div className="absolute inset-x-0 bottom-0 h-1/2 bg-gradient-to-t from-[#050505] to-transparent" />
      </div>

      <div className="relative flex h-full flex-col justify-between px-5 py-24 md:px-12 md:py-28">
        <SectionTag number="03" label="Amaya Energy" />
        <div>
          <h2
            data-testid="intro-title"
            className="intro-title font-display font-bold leading-[0.95] tracking-tight text-white"
            style={{ fontSize: 'clamp(2.2rem, 8vw, 6.5rem)' }}
          >
            {INTRO.title}
          </h2>
          <p className="intro-body mt-8 max-w-xl text-sm leading-relaxed text-white/75 md:text-base">
            {INTRO.body}
          </p>
        </div>
      </div>
    </section>
  );
}
